import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const whatsappLink = "https://wa.me/919353316112?text=Hi%20LitheForce!%20I'm%20interested%20in%20your%20AI%20solutions.";

  const quickLinks = [
    { name: 'Services', href: '#services' },
    { name: 'Pricing', href: '#services' },
    { name: 'Process', href: '#process' },
    { name: 'Why Us', href: '#pricing' },
    { name: 'FAQ', href: '#faq' },
  ];

  return (
    <footer className="bg-[#0d1352] text-white" data-testid="footer">
      <div className="section-container py-12 md:py-16">
        <div className="grid md:grid-cols-4 gap-8 md:gap-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#00e5ff] to-[#1a237e] flex items-center justify-center">
                <span className="text-white font-bold text-sm">LF</span>
              </div>
              <span className="font-semibold text-xl" style={{ fontFamily: 'Outfit, sans-serif' }}>
                LitheForce
              </span>
            </div>
            <p className="text-white/60 mb-4">
              AI-First Software Agency
            </p>
            <div className="flex items-center gap-2 text-white/60">
              <MapPin className="w-4 h-4" />
              <span>Bangalore, India</span>
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Footer navigation">
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-[#00e5ff] transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:dakshasubramanya@litheforce.com"
                  className="flex items-center gap-2 text-white/60 hover:text-[#00e5ff] transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4" />
                  <span className="text-sm">dakshasubramanya@litheforce.com</span>
                </a>
              </li>
              <li>
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-white/60 hover:text-[#00e5ff] transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <Phone className="w-4 h-4" />
                  <span>+91 9353316112</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © 2026 LitheForce. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 hover:text-white/60 text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 hover:text-white/60 text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
